var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 300 300"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__a",
    x1: 0,
    x2: 1,
    y1: 0.5,
    y2: 0.5,
    gradientUnits: "objectBoundingBox",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#b191ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "79%",
    stopColor: "#ff88e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ff8eb3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5 0 0 1.5 -58.42 -42.355)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 209.709,
    height: 204.097,
    fill: "url(#logo_svg__a)",
    rx: 24,
    ry: 24,
    transform: "matrix(.6471 0 0 .71535 71.095 55.255)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M166.247 55.2v41.015c-5.995 24.152-27.82 42.053-53.827 42.053H98.515v-19.913h11.029c19.882 0 36-16.118 36-36V55.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M166.247 201.255V160.24c-5.995-24.152-27.82-42.052-53.827-42.052H98.515V138.1h11.029c19.882 0 36 16.117 36 36v27.154z"
  }))));
};
export default SvgLogo;